import {connect} from '../../app/connect';
import IssuePreviewActivityTab from './IssuePreviewActivityTab';

import {fetchActivities, createCommentAction} from '../../app/actions';
import {
  isFetchingActivities,
  getActivityBlocks,
  getCurrentUserInMcFormat,
  getGroupedProjectActiveEntitiesForMentionComponent,
  activityServiceErrored
} from '../../app/selectors';

const mapStateToProps = state => {
  const isLoading = isFetchingActivities(state);
  const activityBlocks = getActivityBlocks(state);
  return {
    isLoading,
    activityBlocks,
    currentUser: getCurrentUserInMcFormat(state),
    groupedProjectEntitiesForMention: getGroupedProjectActiveEntitiesForMentionComponent(state),
    activityServiceErrored: activityServiceErrored(state)
  };
};

const mapDispatchToProps = {
  fetchActivities,
  createCommentAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssuePreviewActivityTab);
